module.exports = __webpack_public_path__ + "img/ai5.b52ec884.png";